/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum BlendedRateEstimateSource {
  CARRIER_SPECIFIC_REQUESTED = 'CARRIER_SPECIFIC_REQUESTED',
  CARRIER_SPECIFIC_APPROVED = 'CARRIER_SPECIFIC_APPROVED',
  STATE_MEDIAN = 'STATE_MEDIAN',
}
